<template>
  <div class="show-user fl">
    <div class="user ccui-clearfix">
      <img :src="headLogo" class="user-head mr15 fl" />
      <div class="fl">
        <template v-if="loginInfo.name">
          <div class="user-type-welcome">您好，{{ loginInfo.name }}</div>
          <el-link type="primary" @click="handleExit"
            >退出<i class="icon-ccui-next"></i
          ></el-link>
        </template>
        <template v-else>
          <div class="user-type-welcome">采购方登录</div>
          <a class="user-type-link" @click="handleLogin"
            >请登录<i class="icon-ccui-next"></i
          ></a>
        </template>
      </div>
    </div>
    <div class="ccui-clearfix">
      <div class="clearfix-item">
        <a @click="handleHelp(0)">
          <img
            class="fl help-center-img"
            :src="require('@/config/assets/images/ProcurementPlatform.png')"
            style="height: 40px;"
          />
        </a>
        <a @click="handleHelp(1)">
          <img
            class="fl"
            :src="require('@/config/assets/images/SupplySubplatform.png')"
            style="height: 40px;"
          />
        </a>
      </div>
      <div class="clearfix-item">
        <a @click="handleHelp(2)">
          <img
            class="fl help-center-img"
            :src="require('@/config/assets/images/OperationGuide.png')"
            style="height: 40px;"
          />
        </a>
        <a @click="handleHelp(3)">
          <img
            class="fl"
            :src="require('@/config/assets/images/Q&A.png')"
            style="height: 40px;"
          />
        </a>
      </div>
    </div>
    <div class="user-divider">
      <div class="divider-header ccui-clearfix">
        <div class="titleIcon fl">
          <svg-icon icon-class="trumpet" class="icon-trumpet"></svg-icon>
          <span>通知公告</span>
        </div>
        <a class="fr" @click="handleViewAll()">查看全部 ></a>
      </div>
      <ul class="dividerList">
        <li v-for="(item, index) in dividerList" class="ellipsis" :key="index">
          <a :title="item.title" @click="handleOp(item)">
            【{{ item.time }}】 {{ item.title }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { queryPublishedNoticeList } from "@/app/shop/api/shopping";
import Cookies from "js-cookie";
import moment from "moment";
export default {
  name: "showUser",
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dividerList: [],
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      purchaseAgentId: "",
      supplyAgentId: ""
    };
  },
  mounted() {},
  activated() {
    this.init();
  },
  deactivated() {
    this.dividerList = [];
  },
  methods: {
    init() {
      queryPublishedNoticeList({
        pageNo: 1,
        pageSize: 5,
        module: 1,
        pageState: 2,
        textType: 1
        /*appId: 100125*/
      }).then(res => {
        if (res.data.code === "0") {
          this.dividerList = res.data.data.rows.map(item => {
            return {
              ...item,
              time: item.publishTime
                ? moment(item.publishTime).format("MM-DD")
                : ""
            };
          }); // publishTime
        }
      });
    },
    handleOp(row) {
      //通知公告
      this.$router.push({
        path: "/announcementDetail",
        query: {
          id: row.noticeInfoId
        }
      });
    },
    handleHelp(index) {
      // let item = this.imgData[index] ? this.imgData[index] : {};
      // if (item.otherUrl) {
      //   //点击量
      //   updateHits({
      //     publicityContentId: item.publicityContentId
      //   });
      //   window.open(item.otherUrl, "_blank");
      // }
      //  采购子平台
      if (index === 0) {
        if (Cookies.get("access_token")) {
          this.purchaseAgentId = JSON.parse(
            localStorage.getItem("agentIdList")
          ).purchaseAgentId;
          let href = "";
          if (this.baseUrl.indexOf("dev01") != -1) {
            href = `https://dev01-scpma.iccec.cn/index?a=${this.purchaseAgentId}`;
          } else if (this.baseUrl.indexOf("test01") != -1) {
            href = `https://test01-scpma.iccec.cn/index?a=${this.purchaseAgentId}`;
          } else if (this.baseUrl.indexOf("uat01") != -1) {
            href = `https://uat01-scpma.iccec.cn/index?a=${this.purchaseAgentId}`;
          } else {
            href = `https://scpma.iccec.cn/index?a=${this.purchaseAgentId}`;
          }
          window.open(href, "_blank");
        } else {
          window.location.href =
            this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
            "?redirectUrl=" +
            this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
        }
      }
      // 供应子平台
      if (index === 1) {
        if (Cookies.get("access_token")) {
          this.supplyAgentId = JSON.parse(
            localStorage.getItem("agentIdList")
          ).supplyAgentId;
          let href = "";
          if (this.baseUrl.indexOf("dev01") != -1) {
            href = `https://dev01-smp.iccec.cn/?a=${this.supplyAgentId}`;
          } else if (this.baseUrl.indexOf("test01") != -1) {
            // href = `https://test01-smp.iccec.cn/contractManagement/materialContractApproval/approvalList?a=${this.supplyAgentId}`;
            href = `https://test01-smp.iccec.cn/?a=${this.supplyAgentId}`;
          } else if (this.baseUrl.indexOf("uat01") != -1) {
            href = `https://uat01-smp.iccec.cn/?a=${this.supplyAgentId}`;
          } else {
            href = `https://smp.iccec.cn/?a=${this.supplyAgentId}`;
          }
          window.open(href, "_blank");
        } else {
          window.location.href =
            this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
            "?redirectUrl=" +
            this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
        }
      }
      if (index === 2) {
        this.$router.push({
          path: "/operationManual",
          query: {}
        });
        console.log(url, "url");
      }
      if (index === 3) {
        this.$router.push({
          path: "/question",
          query: {}
        });
      }
    },
    //更多 >
    handleViewAll() {
      this.$router.push({
        path: "/announcementsList"
      });
    },
    //退出
    handleExit() {
      localStorage.clear();
      window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(window.location.href);
    },
    //登录
    handleLogin() {
      window.location.href =
        this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        "?redirectUrl=" +
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    }
  },
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    },
    headLogo() {
      if (this.loginInfo.iConLink) {
        return this.loginInfo.iConLink;
      } else {
        return require("@/basa/assets/images/headLogo.png");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.clearfix-item {
  display: flex;
}
.show-user {
  width: 260px;
  height: 370px;
  background: #ffffff;
  .user {
    margin: 26px 15px 20px 15px;
    .user-head {
      width: 52px;
      height: 52px;
    }
    .user-type-welcome {
      height: 28px;
      font-family: PingFang-SC-Medium;
      font-size: 20px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 500;
    }
    .user-type-link {
      height: 18px;
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
}
.divider-header {
  padding: 10px 0 16px 0;
  font-size: 12px;
  line-height: 18px;
  .titleIcon {
    display: inline-block;
    .icon-ccui-bell-o {
      margin-right: 5px;
      color: #ff954e;
    }
    .icon-ccui-bell-o + span {
      color: #4a4a4a;
    }
  }
  .titleIcon + a {
    color: #9b9b9b;
  }
}
.dividerList {
  width: 240px;
  font-size: 13px;
  color: #4a4a4a;
  letter-spacing: 0;
  font-weight: 400;
  li {
    line-height: 18px;
    font-weight: 400;
    margin-bottom: 4px;
  }
}

.fl {
  float: left;
}
.icon-trumpet {
  width: 15.02px;
  height: 14px;
  padding-right: 7px;
}

.help-center-img {
  margin: 0 8px 10px;
}
</style>
